<template>
    <button
        type="button"
        class="task-list-handle"
        :style="{ background: theme.headerFooterColor, color: theme.footerIconColor, borderColor: theme.footerIconColor }"
        :aria-expanded="open ? 'true' : 'false'"
        @click="$emit('toggle')"
    >
        <span class="task-list-handle__bar"></span>
        <span class="task-list-handle__label">{{ open ? closeLabel : openLabel }}</span>
    </button>
</template>

<script>
import { layoutMixin } from '../../utils/layout-mixin';

// Handle of the task list drawer on the mobile map page: a vertical tab like in the native app
export default {
    mixins: [layoutMixin],
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        openLabel: {
            type: String,
            default: '',
        },
        closeLabel: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.task-list-handle {
    display: flex;
    align-items: center;
    padding: 12px 6px;
    border: 1px solid;
    border-left: none;
    border-radius: 0 12px 12px 0;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    cursor: pointer;
    outline: none;
    -webkit-tap-highlight-color: transparent;
}
.task-list-handle__bar {
    flex: 0 0 auto;
    width: 2px;
    height: 48px;
    margin-right: 6px;
    background: currentColor;
    border-radius: 1px;
}
/* the label reads top-down, like the rotated handle of the native drawer */
.task-list-handle__label {
    writing-mode: vertical-rl;
    white-space: nowrap;
    max-height: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
